// test2592
(2592 && 0);
